import { CurrencyField } from "@/components/calculator/fields/CurrencyField";
import { NumberField } from "@/components/calculator/fields/NumberField";
import { YesNoField } from "@/components/calculator/fields/YesNoField";
import { ChoiceField } from "@/components/calculator/fields/ChoiceField";
import { visibleFields } from "@/components/calculator/schemas";
import { getPath } from "@/lib/paths";

const RENDERERS = {
  currency: CurrencyField,
  number: NumberField,
  yesno: YesNoField,
  choice: ChoiceField,
};

/** Renders every currently-relevant question on a step. */
export const StepFields = ({ step, answers, errors, onChange, focusPath, registerRef }) => {
  const fields = visibleFields(step, answers);
  const allYesNo = fields.length > 1 && fields.every((f) => f.type === "yesno");

  return (
    <div className={allYesNo ? "space-y-5" : "space-y-8"}>
      {fields.map((field) => {
        const Renderer = RENDERERS[field.type];
        if (!Renderer) return null;
        return (
          <Renderer
            key={field.path}
            field={field}
            value={getPath(answers, field.path)}
            error={errors?.[field.path]}
            autoFocus={focusPath === field.path}
            registerRef={registerRef}
            onChange={(value, alsoSet) => onChange(field.path, value, alsoSet)}
          />
        );
      })}
    </div>
  );
};
